<template>
  <div class="flex flex-col w-full relative gm-automation-filter">
    <automations-node
      class="relative w-full py-4 px-7"
      :headerNode="true"
      :type="type"
    >
    </automations-node>
    <transition name="bounce">
      <div
        class="flex mt-4 pb-2 px-6 gm-auto-filter-main gm-automation-filter__details"
        v-if="showDetailedView"
      >
        <div class="flex flex-col w-full gm-automation-filter__controls">
          <div class="px-1 gm-automation-filter__field" :class="filterWidthClass">
            <treeselect
              class="gm-automation-filter__treeselect
                h-10
                custom-treeselect
                two-items--treeselect-height
              "
              v-model="filter"
              :multiple="false"
              :options="filterMenuData"
              :closeOnSelect="closeOnSelect"
              :clearOnSelect="clearOnSelect"
              :clearable="clearable"
              :maxHeight="250"
              :placeholder="getFilterHeading()"
              @select="filterChanged($event)"
            />
          </div>
          <div
            v-if="filterOptions && filterOptions.length"
            class="flex flex-wrap gm-automation-filter__options"
            :class="filterOptionsWrapperWidthClass"
          >
            <div
              v-for="(filterOption, index) in filterOptions"
              :key="index"
              class="px-1 gm-automation-filter__field"
              :class="filterOptionWidthClass"
            >
              <treeselect
                v-if="filterOption.type === 'dropdown'"
                class="gm-automation-filter__treeselect
                  h-10
                  custom-treeselect
                  two-items--treeselect-height
                "
                v-model="filterOptionReqPramas[filterOption.id]"
                :multiple="false"
                :maxHeight="250"
                :options="filterOptionsData(filterOption)"
                :closeOnSelect="closeOnSelect"
                :clearOnSelect="clearOnSelect"
                :clearable="clearable"
                :placeholder="getFilterOptionHeading(filterOption)"
                @select="filterOptionChanged($event, filterOption, index)"
              />
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="flex flex-col">
      <div
        v-if="type === 'condition'"
        class="flex w-full items-center pl-7 my-2 gm-automation-filter__negate"
      >
        <p class="mr-2">{{ $t('frontend_groovemail_analytics_list_not') }}</p>
        <gd-toggle
          bgClass="bg-grey-300"
          :value="autoFiltersData.isNegative"
          @change="updatedNegateCondition"
        />
      </div>
      <div class="flex w-full justify-end gm-automation-filter__actions">
        <gd-button
          variant="primary"
          :disabled="!autoFiltersData.saved"
          @click="changeFilterSaveStatus"
          class="gm-automation-filter__add
            mx-7
            mt-2
          "
          :class="{'bg-primary text-primary-invert disabled-btn': !autoFiltersData.saved}"
          ><span class="font-bold mr-4 text-xl">+</span
          >{{ saveBtnText }}</gd-button
        >
      </div>
      <div class="flex justify-center mt-4 gm-automation-filter__cancel-wrap">
        <p @click="closeAutomationNodeModal" class="text-primary cursor-pointer gm-automation-filter__cancel">
          {{ $t('frontend_cancel') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import AutomationsNode from '@/components/automations-v2/automations-node.vue';

export default {
  name: 'automation-filters',

  props: {
    filters: {
      required: true,
    },
    type: {
      required: true,
    },
    automationFiltersData: {
      required: true,
    },
    autoFilterIndex: {
      required: true,
    },
    autoType: {
      required: false,
      default: 'add',
    },
  },

  data() {
    return {
      clearable: false,
      closeOnSelect: true,
      clearOnSelect: true,
      filter: null,
      filtersData: this.filters,
      filterWidthClass: 'w-full',
      filterOptionsWrapperWidthClass: 'w-0',
      filterOptionWidthClass: 'w-0',
      filterOptions: [],
      filterOptionsCount: 0,
      filterOptionReqPramas: {},
      filterOptionNames: {},
      checkFieldOptions: false,
      showDetailedView: true,
      autoFiltersData: { ...this.automationFiltersData },
      saveBtnText: this.$t('frontend_add'),
    };
  },

  watch: {
    filterOptionsCount() {
      if (this.filterOptionsCount > 0) {
        this.filterOptionsWrapperWidthClass = 'w-full mt-4';
        this.filterOptionWidthClass = 'w-full mb-4';
      } else {
        this.filterOptionsWrapperWidthClass = 'w-0';
        this.filterOptionWidthClass = 'w-0';
      }
    },

    checkFieldOptions(valid) {
      this.autoFiltersData.filterValid = valid;
      if (!this.autoFiltersData.filterValid) {
        this.autoFiltersData.saved = 0;
      }
    },
  },

  components: {
    Treeselect,
    AutomationsNode,
  },

  async created() {
    await this.assignAutomationData();
  },

  computed: {
    filterMenuData() {
      const filterMenus = [];
      if (this.filtersData && this.filtersData.length) {
        if (this.type === 'condition') {
          this.filtersData.forEach((element) => {
            if (element.is_positive === +!this.autoFiltersData.isNegative) {
              filterMenus.push({
                id: element.activity_name,
                label: element.condition_name,
              });
            }
          });
        } else {
          this.filtersData.forEach((element) => {
            if (
              (this.type === 'trigger' && element.is_activity) ||
              this.type === 'action'
            ) {
              filterMenus.push({
                id: element.activity_name,
                label: element.name,
              });
            }
          });
        }
      }
      return filterMenus;
    },
  },

  methods: {
    async assignAutomationData() {
      if (
        this.autoFiltersData &&
        this.autoFiltersData.activity_name &&
        this.autoFiltersData.config &&
        this.autoFiltersData.config_name
      ) {
        this.filter = this.autoFiltersData.activity_name;
        this.filterOptionReqPramas = { ...this.autoFiltersData.config };
        this.filterOptionNames = { ...this.autoFiltersData.config_name };
        await this.getFiltersData(null, this.filterOptionReqPramas);
      }
    },

    getFilterHeading() {
      let filterHeading = this.$t('frontend_select');
      if (this.type === 'trigger') {
        filterHeading = this.$t(
          'frontend_groovemail_automations_trigger_select'
        );
      } else if (this.type === 'condition') {
        filterHeading = this.$t(
          'frontend_groovemail_automations_select_condition'
        );
      } else {
        filterHeading = this.$t('frontend_automations_select_action');
      }
      return filterHeading;
    },

    getFilterOptionHeading(option) {
      let filterOptionHeading = '';
      if (option && option.label) {
        if (option.isMandatory) {
          filterOptionHeading = `${this.$t('frontend_select')} ${option.label}`;
        } else {
          filterOptionHeading = `${this.$t(
            'frontend_groovemail_automations_any_label'
          )} ${option.label}`;
        }
      } else {
        filterOptionHeading = `${this.$t('frontend_select')}`;
      }
      return filterOptionHeading;
    },

    filterOptionsData(option) {
      const filterOptions = [];
      if (option && option.values && option.values.length) {
        option.values.forEach((element) => {
          filterOptions.push({
            id: element.id,
            label: element.name || element.redirect_url,
          });
        });
      }
      return filterOptions;
    },

    async filterChanged(filter) {
      this.setFilterOptionsData();
      this.checkFieldOptions = false;
      if (filter) {
        this.getFiltersData(filter, null);
      }
    },

    async filterOptionChanged(filter, option, index) {
      const filterOptionReqPramasObj = {};
      filterOptionReqPramasObj[option.id] = filter.id;
      this.filterOptionReqPramas = {
        ...this.filterOptionReqPramas,
        ...filterOptionReqPramasObj,
      };
      this.filterOptionNames[option.id] = filter.label;
      if (this.filterOptions.length - 1 > index) {
        this.prepareFilterOptionParams(this.filterOptions, index + 1);
        await this.getFiltersData(filter, this.filterOptionReqPramas);
      } else {
        this.allowAddFilterOption();
      }
    },

    async getFiltersData(filter, reqParams) {
      const requestBody = {
        type: this.type,
        activity_name: reqParams ? this.filter : filter.id,
      };
      await this.fetchFilterOptions(reqParams, requestBody);
      this.allowAddFilterOption();
    },

    async fetchFilterOptions(requestParams, requestBody) {
      this.$emit('showLoader');
      try {
        let filterOptions;
        if (requestParams) {
          const reqParams = { ...requestParams };
          Object.keys(reqParams).forEach(
            (k) => !reqParams[k] && delete reqParams[k]
          );
          filterOptions = await axios.post(
            '/automation_v2/filters',
            requestBody,
            { params: reqParams }
          );
          this.setFilterOptionsData(
            filterOptions.data.data,
            filterOptions.data.total_dropdown
          );
        } else {
          this.filterOptionReqPramas = {};
          this.filterOptionNames = {};
          filterOptions = await axios.post(
            '/automation_v2/filters',
            requestBody
          );
          this.setFilterOptionsData(
            filterOptions.data.data,
            filterOptions.data.total_dropdown
          );
          this.prepareFilterOptionParams(filterOptions.data.data);
        }
        this.$emit('hideLoader');
      } catch (err) {
        this.$emit('hideLoader');
      }
    },

    allowAddFilterOption() {
      const currentFieldOptionsValid = [];
      let fieldIndex = 0;
      this.filterOptions.forEach((element) => {
        if (
          (element.isMandatory && this.filterOptionReqPramas[element.id]) ||
          !element.isMandatory
        ) {
          currentFieldOptionsValid[fieldIndex] = true;
        } else {
          currentFieldOptionsValid[fieldIndex] = false;
        }
        fieldIndex++;
      });
      let allowAdding = 0;
      currentFieldOptionsValid.forEach((element) => {
        if (element) allowAdding++;
      });
      this.checkFieldOptions =
        allowAdding && allowAdding === this.filterOptions.length;
      this.autoFiltersData.saved = this.checkFieldOptions ? 1 : 0;
    },

    setFilterOptionsData(filterOptionsData, filterOptionsCount = 0) {
      this.filterOptions =
        filterOptionsData && filterOptionsData.length ? filterOptionsData : [];
      this.filterOptionsCount = filterOptionsCount;
    },

    prepareFilterOptionParams(filterOptionsData, index = 0) {
      if (filterOptionsData && filterOptionsData.length) {
        const filterOptionReqPramasObj = {};
        for (let i = index; i < filterOptionsData.length; i++) {
          filterOptionReqPramasObj[filterOptionsData[i].id] = null;
          this.filterOptionNames[filterOptionsData[i].id] = null;
        }
        this.filterOptionReqPramas = {
          ...this.filterOptionReqPramas,
          ...filterOptionReqPramasObj,
        };
      }
    },

    creationAutomationField() {
      const filterData = this.filtersData.find(
        (ele) => ele.activity_name === this.filter
      );
      this.filterOptions.forEach((element) => {
        if (!element.isMandatory && !this.filterOptionNames[element.id]) {
          this.filterOptionNames[element.id] = `${this.$t(
            'frontend_groovemail_automations_any_label'
          )} ${element.label}`;
        }
      });
      const automationFilterObj = {
        activity_name: this.filter,
        activity_label:
          this.type === 'condition'
            ? filterData.condition_name
            : filterData.name,
        config: { ...this.filterOptionReqPramas },
        config_name: { ...this.filterOptionNames },
      };
      if (filterData && filterData.hasOwnProperty('is_activity')) {
        automationFilterObj.is_activity = filterData.is_activity;
      }
      if (filterData && filterData.hasOwnProperty('icon')) {
        automationFilterObj.icon = filterData.icon;
      }
      this.$emit(
        'filterDataChanged',
        { ...this.autoFiltersData, ...automationFilterObj },
        this.autoFilterIndex,
        this.autoType
      );
    },

    getFilterName(filterOptionNames) {
      let filterOptionsValueName = '';
      const filterOptionsArray = Object.keys(filterOptionNames);
      for (
        let filterIn = 0;
        filterIn <= filterOptionsArray.length - 1;
        filterIn++
      ) {
        if (filterIn === filterOptionsArray.length - 1) {
          filterOptionsValueName += `${
            filterOptionNames[filterOptionsArray[filterIn]]
          }`;
        } else {
          filterOptionsValueName += `${
            filterOptionNames[filterOptionsArray[filterIn]]
          }, `;
        }
      }
      return filterOptionsValueName;
    },

    updatedNegateCondition() {
      this.autoFiltersData.isNegative = !this.autoFiltersData.isNegative;
      this.filter = null;
      this.filterOptionReqPramas = {};
      this.filterOptionNames = {};
      this.filterOptions = [];
      this.filterOptionsCount = 0;
      this.autoFiltersData.filterValid = false;
      this.checkFieldOptions = false;
    },

    changeFilterSaveStatus() {
      this.autoFiltersData.saved = 1;
      if (this.checkFieldOptions) {
        this.creationAutomationField();
      }
    },

    closeAutomationNodeModal() {
      this.$emit('closeAutomationNodeModal');
    },
  },
};
</script>

<style lang="scss">
.bounce-enter-active {
  animation: bounce-in 0.25s;
}
.bounce-leave-active {
  animation: bounce-in 0.25s reverse;
}

@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

.af-caret-rotate-0 {
  transform: rotate(0deg);
}

.af-caret-rotate-180 {
  transform: rotate(180deg);
}

.gm-auto-filter-main {
  .two-items--treeselect-height {
    .vue-treeselect__menu-container {
      .vue-treeselect__list {
        max-height: 435px !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.gm-automation-filter {
  color: var(--gs-foreground);

  &__details {
    background: var(--gs-surface);
  }

  &__controls,
  &__field,
  &__options {
    min-width: 0;
  }

  &__treeselect {
    min-height: 2.75rem;
  }

  ::v-deep .gm-automation-filter__treeselect .vue-treeselect__control {
    min-height: 2.75rem;
    height: auto;
    align-items: stretch;
    border-color: var(--gs-border-strong);
  }

  ::v-deep .gm-automation-filter__treeselect .vue-treeselect__single-value:not(.vue-treeselect-helper-hide),
  ::v-deep .gm-automation-filter__treeselect .vue-treeselect__placeholder:not(.vue-treeselect-helper-hide) {
    display: flex;
    align-items: center;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: auto;
    white-space: normal;
    overflow-wrap: anywhere;
    line-height: 1.25;
  }

  ::v-deep .gm-automation-filter__treeselect .vue-treeselect__input-container input {
    min-width: 0;
  }

  ::v-deep .gm-automation-filter__treeselect .vue-treeselect__option {
    min-height: 2.75rem;
    display: flex;
    align-items: center;
    white-space: normal;
    overflow-wrap: anywhere;
    line-height: 1.25;
  }

  &__add {
    min-height: 2.75rem;
  }

  &__add:not([disabled]):not(.disabled-btn) {
    background: var(--gs-primary);
    color: var(--gs-primary-foreground);
  }

  &__add:focus-visible,
  &__cancel:focus-visible {
    outline: 2px solid var(--gs-primary);
    outline-offset: 2px;
  }

  &__cancel {
    min-height: 2.75rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border: 1px solid var(--gs-border-strong);
    border-radius: 0.25rem;
    color: var(--gs-foreground);
    background: var(--gs-surface);
  }

  @media (max-width: 40rem) {
    &__details {
      margin-top: 0.75rem;
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }

    &__negate {
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }

    &__actions {
      padding: 0 0.75rem;
    }

    &__add {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }

    &__cancel-wrap {
      padding: 0 0.75rem;
    }

    &__cancel {
      width: 100%;
    }
  }
}
</style>
